import styled from "styled-components";
import CustomButton from "components/CustomElements/CustomButton";

export const StyledCustomButton = styled(CustomButton)`
margin-right: 0;
`;